import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import BundleCard from './bundle-card';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AddTrip } from '../../../actions/booking';
import { AddTripPayload } from '../../../helpers/bookingHelper';
import Spinner from '../../shared/spinner';
import Slider from "react-slick";
import { FetchProducts } from '../../../actions/product';



class Bundles extends PureComponent {

  constructor(props){
    super(props);

    this.onAddBundle = this.onAddBundle.bind(this);
    this.onBundleClose = this.onBundleClose.bind(this);

  }

  componentDidUpdate(prevProps, prevState){

    const { upgrades, bookingGroup, FetchProducts } = this.props;

    if(upgrades !== prevProps.upgrades){

      if(upgrades.length > 0){

        //Recall products with upgrades Tour ids
        let filteredUpgradeTourID = upgrades.map(item => item.tour_id);
        filteredUpgradeTourID.unshift(bookingGroup.trips[0].tour_id);

        FetchProducts(bookingGroup.trips[0].iso_currency_code, filteredUpgradeTourID);
      }
    }

  }

  onBundleClose(){
    const element = ReactDOM.findDOMNode(this);
    element.style.opacity = '0';
    setTimeout(()=>{
      element.parentNode.removeChild(element);
    },500);
  }

  onAddBundle(index){

    const { AddTrip, bookingGroup, upgrades } = this.props;


    //Add trip bundle to basket
    const payload = AddTripPayload(bookingGroup, upgrades[index].tour_id, upgrades[index].departure_date );
    AddTrip(bookingGroup, payload);

  }

  render(){

    const { upgrades, products, bookingGroup, isUpdating, iscyoa, type } = this.props;
    
    let conditions, tour_name;

    if(type === "payment") {
      conditions = upgrades.length === 0 || products.length === 1 || bookingGroup.trips.length === 2 || iscyoa;
      tour_name = (Object.keys(bookingGroup).length > 0 && bookingGroup.trips.length > 0) ? bookingGroup.trips[0].tour_name : "";
    }

    if(conditions){
      return null;
    }
    else{

      const SLICK_SETTINGS = {
        cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
        centerMode:false,
        arrows:false,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: (upgrades.length === 1 ) ? 1 : 3,
        slidesToScroll: 1,
        responsive: [
         {
           breakpoint: 1024,
           settings: {
             slidesToShow: (upgrades.length === 1 ) ? 1 : 3,
             slidesToScroll: 1,
             arrows:false
           }
         },
         {
           breakpoint: 700,
           settings: {
             slidesToShow: (upgrades.length === 1 ) ? 1 : 2,
             slidesToScroll: 1,
             arrows:false
           }
         },
         {
           breakpoint: 480,
           settings: {
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows:false
           }
         }
       ]
      }
      


      return (
        <div className="bundles">
          <div className="row">
            <div className="column small-12">
              <button onClick={this.onBundleClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  <path d="M217.5 256l137.2-137.2c4.7-4.7 4.7-12.3 0-17l-8.5-8.5c-4.7-4.7-12.3-4.7-17 0L192 230.5 54.8 93.4c-4.7-4.7-12.3-4.7-17 0l-8.5 8.5c-4.7 4.7-4.7 12.3 0 17L166.5 256 29.4 393.2c-4.7 4.7-4.7 12.3 0 17l8.5 8.5c4.7 4.7 12.3 4.7 17 0L192 281.5l137.2 137.2c4.7 4.7 12.3 4.7 17 0l8.5-8.5c4.7-4.7 4.7-12.3 0-17L217.5 256z"/>
                </svg>
              </button>
              <h5 className="busabout-h5 title">Recommended Trip Bundles</h5>
              <p>Save 10% off the total price when booking {tour_name} with any of these <span className="bold">{upgrades.length} recommended trips.</span></p>
              <div className="bundle-wrapper">
                <div className="row">
                  <Slider {...SLICK_SETTINGS}>
                  {
                    upgrades.map((item, i) => {
                      return (
                        <div key={i} className={`column small-12 medium-4 ${i === upgrades.length-1 ? 'end' : ''}`}>
                          <BundleCard onAddBundle={this.onAddBundle} data={item} cyoaProducts={products} index={i} bookingGroupTrips={bookingGroup.trips} />
                        </div>
                      )
                    })
                  }
                  </Slider>
                </div>
              </div>
            </div>

            <div className="bundle-loading" style={{display: isUpdating ? 'block' : 'none' }}>
              <div className="column small-12 text-center">
                  <Spinner text="Updating bundle..." loadClass="loading-spinner" />
              </div>
            </div>

          </div>
        </div>
      )
    }
  }

}


function mapStateToProps(state){
  return {
    upgrades:state.upgrades.data,
    bookingGroup:state.bookingGroup.data,
    isUpdating:state.bookingGroup.updating,
    products:state.products
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    AddTrip,
    FetchProducts
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Bundles);



// WEBPACK FOOTER //
// ./src/components/shared/bundles/bundles.js